import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        height: '100%',
        flexGrow: 1,
        backgroundColor: theme?.app?.applicationColors.enumColors.offWhite ||
            '#f3f3f3',
        position: 'relative' as const
    },
    toolbarContainer: {
        padding: '0 1.5rem',
        position: 'absolute' as const,
        top: '.75rem',
        zIndex: 100,
        minWidth: '200px',
        width: 'inherit'
    },
    buttonToolbar: {
        zIndex: 100,
        flexBasis: 'auto' as const
    },
    gridParentContainer: { flexGrow: 1 },
    gridContainer: {
        height: '100%',
        flexGrow: 1,
        padding: '0 1rem'
    },
    filterBar: {
        flexBasis: 'auto',
        paddingTop: '.5rem',
        paddingBottom: '.25rem'
    }
});